import { initializeApp } from "firebase/app";
import { 
  getFunctions, 
  connectFunctionsEmulator 
} from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCuQJJ1IFAgy0u1NKB2ZWeUjJyQh3M9zB4",
  authDomain: "talonyhtioportaalibackend.firebaseapp.com",
  projectId: "talonyhtioportaalibackend",
  storageBucket: "talonyhtioportaalibackend.appspot.com",
  messagingSenderId: "657870431817",
  appId: "1:657870431817:web:92d9e56802ca3f7a730198",
  measurementId: "G-18MTQTLQG6"
};

const app = initializeApp(firebaseConfig);

const functions = getFunctions(app, "europe-north1");

if (window.location.hostname === "localhost") {
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
}

const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage, functions, app };
